/*
 Задача - преобразовать текст в граф. 
 Какие бывают узлы:
  - Seq - последовательность - Data = Array блоков, которые нужно последовательно вставить в строку
  - Var - один из вариантов - Data = Array блоков, нужно выбрать 1 и вставить в строку
  - Chunk - просто текст - Data = String - просто взять текст и вставить его.
*/

function generateTextGraph (str, vars = false) {
  if (vars) {
    // Отдаем массив вариантов
    let result = [];
    let index = 0;
    let curChunk = '';
    let innerBlocks = 0;
    while (index < str.length) {
      if (str[index] != '|' || innerBlocks != 0) {
        curChunk += str[index];
      } else {       
        if (curChunk.includes('{')) {
          result.push(generateTextGraph(curChunk))
        } else {
          result.push({
            tp: 'chunk',
            data: curChunk
          });
          curChunk = '';
        }
      }
      if (str[index] == '{') innerBlocks++;
      if (str[index] == '}') innerBlocks--;
      index++;
    }
    if (curChunk.includes('{')) {
      result.push(generateTextGraph(curChunk))
    } else {
      result.push({
        tp: 'chunk',
        data: curChunk
      });
    }
    return {
      tp: 'var',
      data: result
    }
    
  } else {
    // Отдаем последовательность (или просто чанк)
    if (!str.includes('{')) return {
      tp: 'chunk',
      data: str
    };
    let result = [];
    let index = 0;
    let curChunk = '';
    while (index < str.length) {
      if (str[index] != '{') {
        curChunk += str[index];
        index++;
      } else {       
        if (curChunk != '') {
          result.push({ tp: 'chunk', data: curChunk });
          curChunk = '';
        }
        let indStart = index + 1;
        let indEnd = indStart;
        let blockCount = 1;
        while (blockCount != 0) {
          if (str[indEnd] == '{') blockCount++;
          if (str[indEnd] == '}') blockCount--;
          indEnd++;
        }
        result.push(generateTextGraph(str.substring(indStart, indEnd - 1), true));
        index = indEnd;  
      }
    }
    if (curChunk != '') result.push({ tp: 'chunk', data: curChunk });
    return {
      tp: 'seq',
      data: result
    }
  }
};

function generateRand (graph, isRoot) {
  let result = '';
  switch (graph.tp) {
    case 'chunk':
      result = graph.data;
      break;
    case 'seq':
      for (let v of graph.data) {
        result += generateRand(v);
      }
      break;
    case 'var':
      result += generateRand(graph.data[Math.floor(Math.random() * 1000) % graph.data.length]);
      break;
  }
  return result;
};

export default { generateRand, generateTextGraph };